import { AuthorizationCredentialsServiceFactory } from 'frontcore/domain/authorization/factory'
import { LogoutEmit } from 'frontcore/domain/authorization/model/types'

class UseCredentialsLogout {

  readonly #emit: LogoutEmit

  constructor (emit: LogoutEmit) {
    this.#emit = emit
  }

  use () {
    const loginService = AuthorizationCredentialsServiceFactory.build()
    return () => {
      loginService.logout()
      this.#emit('logoutSuccess')
    }
  }
}

export default UseCredentialsLogout
